module.exports = __webpack_public_path__ + "static/media/feat_olympia.061a042f.png";